import Modal from "react-modal";
import "./style.css";
import useAppAccessor from "../../hooks/useappAccessor";
import { getBrandColor } from "../../utils/brand.util";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    height: "auto",
    width: "90%",
    maxWidth: "480px",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    padding: 0,
    border: "none",
    outline: "none",
    transform: "translate(-50%, -50%)",
    overflow: "hidden",
    borderRadius: 20,
    zIndex: 99999,
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.4), 0 4px 16px rgba(0, 0, 0, 0.3)",
  },
  overlay: {
    backgroundColor: "rgba(24, 24, 24, 0.8)",
    backdropFilter: "blur(4px)",
    zIndex: 99999,
  },
};

const EndStreamModal = (props: any) => {
  const { getUserData } = useAppAccessor();
  const { language, client } = getUserData();
  
  const isHost = () => {
    return window.location.href.indexOf("/stream") > -1;
  };

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
  }

  function closeModal() {
    // setIsOpen(false);
    // props.handleCloseMediaInteraction()
  }

  const isMobile =
    window.innerWidth < 768 ||
    /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent);


  const brandColor = getBrandColor(client);

  const customStylesMobile = {
    content: {
      top: "auto",
      left: 0,
      right: 0,
      width: "100%",
      border: "none",
      outline: "none",
      bottom: 0,
      padding: 0,
      borderRadius: "24px 24px 0 0",
      boxShadow: "0 -4px 20px rgba(0, 0, 0, 0.5), 0 -2px 8px rgba(0, 0, 0, 0.3)",
    },
    overlay: {
      backgroundColor: "rgba(24, 24, 24, 0.8)",
      backdropFilter: "blur(4px)",
      zIndex: 99999,
    },
  };

  return (
    <Modal
      isOpen={props.modalIsOpen}
      onAfterOpen={afterOpenModal}
      onRequestClose={closeModal}
      style={isMobile ? customStylesMobile : customStyles}
      contentLabel="End Stream Confirmation Modal"
    >
      <div
        className="flex w-full items-center justify-center relative"
        style={{
          background: "linear-gradient(145deg, #2d2d2d 0%, #1a1a1a 100%)",
          minHeight: isMobile ? "auto" : "280px",
        }}
      >
        <div className="absolute top-0 left-0 right-0 h-1 rounded-t-full" style={{ backgroundColor: brandColor }} />
        
        <div className="flex flex-col justify-center items-center px-8 py-8 w-full">
          <div className="mb-6 text-center">
            <h2 className="text-2xl font-semibold text-white mb-2 tracking-tight">
              {language["exit_livestream"]}
            </h2>
            <p className="text-sm text-gray-300 mt-2">
              {isHost() 
                ? (language["exit_livestream_confirmation"] || "Are you sure you want to end the livestream?")
                : (language["exit_livestream_attendee_confirmation"] || "Are you sure you want to leave the livestream?")
              }
            </p>
          </div>

          <div className="flex gap-4 w-full max-w-xs">
            <button
              className="flex-1 px-6 py-3 rounded-xl text-white font-medium transition-all duration-200 active:scale-95 border border-white/20 hover:border-white/40 hover:bg-white/5"
              onClick={() => {
                props.handleClickOnNo();
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.1)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "transparent";
              }}
            >
              {language["no_button"]}
            </button>
            <button
              className="flex-1 px-6 py-3 rounded-xl text-white font-semibold transition-all duration-200 active:scale-95 shadow-lg"
              onClick={() => {
                props.handleClickOnyes();
              }}
              style={{ 
                backgroundColor: brandColor,
                boxShadow: `0 4px 12px ${brandColor}40`
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.opacity = "0.9";
                e.currentTarget.style.transform = "translateY(-1px)";
                e.currentTarget.style.boxShadow = `0 6px 16px ${brandColor}60`;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.opacity = "1";
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = `0 4px 12px ${brandColor}40`;
              }}
            >
              {language["yes_button"]}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default EndStreamModal;
